var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-black bg-opacity-10 rounded border border-white border-opacity-40 p-1",
    },
    [
      _c("div", { staticClass: "relative" }, [
        _c("div", {
          staticClass:
            "absolute rounded h-full bg-lime transition-all duration-500 -z-10",
          style: _vm.style,
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid gap-1 grid-flow-col" },
          _vm._l(_vm.options, function (option) {
            return _c(
              "label",
              {
                key: option.value,
                ref: "options",
                refInFor: true,
                staticClass:
                  "inline-block focus-within:outline focus-within:outline-auto",
              },
              [
                _c("input", {
                  staticClass: "hidden peer",
                  attrs: { type: "radio", name: _vm.name },
                  domProps: {
                    value: option.value,
                    checked: option.value === _vm.value,
                  },
                  on: { change: _vm.handleChange },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "block text-center custom-label-tighter p-2 rounded cursor-pointer peer-checked:pointer-events-none transition-colors font-[500]",
                  domProps: { textContent: _vm._s(option.label) },
                }),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }